import { connect } from 'react-redux';

import View from './';

const mapStateToProps = state => ({ intl: state.intl });
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/components/switch/container.js